module.exports = __webpack_public_path__ + "img/cow.f2d42403.png";